import { DEFAULT_PIEVE_MODEL_ID, DEFAULT_PIEVE_REASONING_EFFORT } from '@shared/pieve/defaultModel.js';
import createThread from '@/redux/actions/pieveActions/createThread.js';
import sendPrompt from '@/redux/actions/pieveActions/sendPrompt.js';
import AUTOMATION_KINDS from './AUTOMATION_KINDS.js';

/**
 * Sends a request about an automation to Pieve. With `threadId` the message goes to the automation's own
 * conversation (to change it); without it a new conversation opens in the kind's building mode, so Pieve
 * can set the automation up without first asking to switch modes. Resolves to { success, threadId } or
 * { success: false, message }.
 */
const askPieveAboutAutomation = ({ kind, threadId = null, prompt }) => {
  return async (dispatch) => {
    const request = String(prompt || '').trim();

    if (!request) {
      return { success: false, message: 'Describe what Pieve should do.' };
    }

    let targetThreadId = String(threadId || '').trim();

    if (!targetThreadId) {
      const created = await dispatch(
        createThread({
          title: `New ${AUTOMATION_KINDS[kind].singular.toLowerCase()}`,
          threadType: AUTOMATION_KINDS[kind].threadType,
          composerModel: DEFAULT_PIEVE_MODEL_ID,
          composerReasoningEffort: DEFAULT_PIEVE_REASONING_EFFORT
        })
      );
      targetThreadId = String(created?.id || created?.threadId || '').trim();

      if (!targetThreadId) {
        return { success: false, message: created?.error?.message || 'The conversation could not be opened.' };
      }
    }

    const sent = await dispatch(sendPrompt({ threadId: targetThreadId, prompt: request }));

    if (sent?.success === false) {
      return { success: false, message: sent.message || 'Your message could not be sent.', threadId: targetThreadId };
    }

    return { success: true, threadId: targetThreadId };
  };
};

export default askPieveAboutAutomation;
